import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/long-arrow-right.svg'


const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-be-part-of-it"
}
const _hoisted_2 = { class: "home-be-part-of-it-item" }
const _hoisted_3 = { class: "home-be-part-of-it-title" }
const _hoisted_4 = { class: "home-be-part-of-it-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "home-be-part-of-it-arrow",
  src: _imports_0,
  alt: "Link"
}, null, -1)
const _hoisted_8 = { class: "home-be-part-of-it-image" }
const _hoisted_9 = ["src"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { VUE_APP_PARTNER_FORM, VUE_APP_CLINIC_FORM } = process.env;

const items = [
  {
    title: "Seja um Parceiro Obmed",
    content:
      "De forma <b>simples</b>, <b>prática</b> e <b>em qualquer lugar</b>, facilite a vida de seus amigos e familiares e tenha uma <b>renda extra</b>... é só agendar e esperar o dinheiro na sua conta. Venha ser nosso parceiro!",
    img: require("@/assets/images/partner.png"),
    linkText: "Acessar Obmed Parceiro",
    linkAddress: VUE_APP_PARTNER_FORM,
    reverseImage: true,
  },
  {
    title: "Seja uma Clínica credenciada Obmed",
    content:
      "<b>Aumente</b> o seu fluxo de pacientes, <b>reduzindo</b> a taxa de ausências, gerindo da <b>melhor</b> forma suas agendas com mais <b>praticidade</b>. Venha ser uma clínica credenciada!",
    img: require("@/assets/images/clinic.jpg"),
    linkText: "Acessar formulário",
    linkAddress: VUE_APP_CLINIC_FORM,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
      return _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("div", {
          class: _normalizeClass(['home-be-part-of-it-container', { 'is-reverse-image': item.reverseImage }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: "home-be-part-of-it-text",
              innerHTML: item.content
            }, null, 8, _hoisted_5),
            _createElementVNode("a", {
              class: "home-be-part-of-it-button button is-primary",
              href: item.linkAddress,
              target: "_blank",
              rel: "noreferrer"
            }, [
              _createTextVNode(_toDisplayString(item.linkText) + " ", 1),
              _hoisted_7
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: item.img,
              alt: "Faça parte da Obmed!"
            }, null, 8, _hoisted_9)
          ])
        ], 2)
      ])
    }), 64))
  ]))
}
}

})